import Swiper from 'swiper';

(function ($) {
	/**
	 * initializeSwiper
	 *
	 * Initializes the Swiper slider.
	 *
	 * @return  Swiper instance
	 */
	const initializeSwiper = function ($block) {
		const swiperContainer = $block.find('.swiper')[0];
		const swiperNext = $block.find('.swiper-button-prev');
		const swiperPrev = $block.find('.swiper-button-next');

		const swiper = new Swiper(swiperContainer, {
			direction: 'horizontal',
			slidesPerView: 'auto',
			spaceBetween: 16,
			slidesPerGroup: 3,
		});

		swiperNext.on('click', function () {
			swiper.slidePrev();
		});
		swiperPrev.on('click', function () {
			swiper.slideNext();
		});

		return swiper;
	};

	/**
	 * initializeBlock
	 *
	 * Initializes Swiper slider or converts it to a list on mobile.
	 *
	 * @return  void
	 */
	const initializeBlock = function ($block) {
		const breakpoint = 768;
		let swiperInstance;

		const setListMode = function () {
			// Destroy swiper if it exists
			if (swiperInstance && swiperInstance.destroy) {
				swiperInstance.destroy(true, true);
			}

			// Add list styling for mobile
			$block
				.find('.swiper')
				.removeClass('swiper-container')
				.addClass('list-mode');
			$block.find('.swiper-wrapper').css('display', 'block');

			// Show only the first 3 slides in mobile view
			$block
				.find('.swiper-slide')
				.css({
					width: '100%',
					display: 'block',
				})
				.hide(); // First hide all slides
			$block.find('.swiper-slide').slice(0, 3).show(); // Show only the first 3

			// Hide swiper buttons on mobile
			$block.find('.swiper-button-prev, .swiper-button-next').hide();
		};

		const setSliderMode = function () {
			// Revert back to swiper if screen is larger than the breakpoint
			$block
				.find('.swiper')
				.removeClass('list-mode')
				.addClass('swiper-container');
			$block.find('.swiper-wrapper').css('display', '');
			$block.find('.swiper-slide').css({
				width: '',
				display: '',
			});

			// Show swiper buttons on larger screens
			$block.find('.swiper-button-prev, .swiper-button-next').show();

			// Initialize swiper if it doesn't already exist
			swiperInstance = initializeSwiper($block);
		};

		const checkScreenSize = function () {
			if (window.innerWidth < breakpoint) {
				setListMode(); // Mobile view: list mode
			} else {
				setSliderMode(); // Desktop view: swiper mode
			}
		};

		// Check screen size on page load
		checkScreenSize();

		// Re-check on window resize
		$(window).resize(checkScreenSize);
	};

	// Initialize each block on a page load (front end)
	$(document).ready(function () {
		$('.wp-block-acf-blog-section-block').each(function () {
			initializeBlock($(this));
		});
	});

	// Initialize dynamic block preview (editor)
	if (window.acf) {
		window.acf.addAction(
			'render_block_preview/type=blog-section-block',
			function ($block) {
				initializeBlock($($block));
			}
		);
	}
})(jQuery);
